import useGet from "api/useGet";
import { useNavigate } from "react-router-dom";
import {CustomMenu, CustomSelect} from "../basic/formItems";
import React from "react";

//footer
function FooterInfo(data){
    return (
        <div className="footer_infoItem">
            <p className="footer_infoName" dangerouslySetInnerHTML={{__html:data.name}}/>
            <p className="footer_info" dangerouslySetInnerHTML={{__html:data.text}}/>
        </div>
    );
}

function FooterMenu(data){
    return (
        <button type="button" onClick={()=>{data.func()}} className={`footer_menu ${data.addClass ? data.addClass : ""}`} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.contents}}/>
    );
}

function Footer(data){
    const navigate = useNavigate();

    return (
        <div className={`footer ${data.pcOnly ? "pcItemT" : ""}`}>
            <div className="footerSection">
                <div className="footerTopBox">
                    <div className="footerTopItem">
                        <div className="footerLogo">
                            <img src="/assets/images/img/logo_g.png"/>
                        </div>
                        <div className="footer_menuBox">
                            <FooterMenu func={()=>{window.termsPopupOpen("service","이용약관")}} contents="이용약관"/>
                            <FooterMenu func={()=>{window.termsPopupOpen("privacy","개인정보처리방침")}} contents="개인정보처리방침"/>
                            <FooterMenu func={()=>{window.termsPopupOpen("trouble","소비자 분쟁해결 기준")}} contents="소비자 분쟁해결 기준"/>
                        </div>
                    </div>
                    <div className="footerTopItem">
                        <CustomMenu
                            addClass="absoluteSel"
                            value="Family Site"
                            func={(name, val) => {
                                window.open(
                                    val,
                                    "_blank"
                                );
                            }}
                            disabled={false}
                            valKey="id"
                            nameKey="name"
                            options={[
                                {id: "https://www.amano.co.kr/", name: "아마노"},
                                {id: "https://blog.naver.com/amanoparking/224215426285", name: "아마노파킹허브"},
                                {id: "https://valet.amanopark.co.kr/", name: "인천공항 주차대행"},
                                {id: "https://cheongjuvalet.amanopark.co.kr/", name: "청주공항 주차대행"}
                            ]}
                        />
                    </div>
                </div>
                <div className="footer_infoArea">
                    <p className="footer_description">AMANO 렌터카허브는 제휴사(입점, 비입점)가 제공하는 상품 정보를 비교·중개하는 플랫폼입니다. 아마노코리아㈜는 통신판매 당사자가 아닌 통신판매중개자로서, 상품 정보·거래·이용 및 환불 등에 대한 책임은 각 판매자에게 있습니다.</p>
                    <p className="footer_companyName">아마노코리아(주)에이렌터카허브</p>
                    <div className="footer_infoBox">
                        <FooterInfo
                            name="대표이사"
                            text="전 명 진"
                        />
                        <FooterInfo
                            name="주소"
                            text="제주특별자치도 제주시 서해안로 542, 3층  307호 (용담삼동, 에이렌터카허브)"
                        />
                        <FooterInfo
                            name="사업자 등록번호"
                            text="699-85-03051"
                        />
                        <FooterInfo
                            name="통신판매업신고"
                            text="제 2025- 용담2동-054 호"
                        />
                        <FooterInfo
                            name="고객센터"
                            text="064-711-3200"
                        />
                        <FooterInfo
                            name="E-Mail"
                            text="admin@a-rentacar.co.kr"
                        />
                    </div>
                </div>
                <p className="footer_caption">Copyright(C) Amano Korea Co., Ltd. All Right Reserved.</p>
            </div>
        </div>
    );
}

export {Footer}